// 2026-10-30 (owner) — "+999%" read as maxed out. Spikes of +100% or more
// render as a multiple ("12×", "1.2k×"); smaller moves keep the percent.
// Mirrored in mobile/src/lib/spikeLabel.js.
export function spikeLabel(entity) {
  const m = entity?.mention_multiple;
  const d = entity?.mention_delta_pct;
  if (typeof m === 'number' && m >= 2) {
    if (m >= 1000) return `${(m / 1000).toFixed(1)}k×`;
    return `${m >= 10 ? Math.round(m) : m.toFixed(1)}×`;
  }
  if (typeof d === 'number') return `${d > 0 ? '+' : ''}${Math.round(d)}%`;
  return null;
}
